





















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ICurrency, ICurrencyRate } from '@/models/currency';
import { ISystemError } from '@/models/error/error.types';
import { SystemError } from '@/models/error/error';

import { setErrorFromAxiosError } from '@/utils/helpers';

export default Vue.extend({
  name: 'currencyPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'currencies'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | ISystemError>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      fetchError: null as ISystemError | null,
      currencyLoading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      currencyRates: 'currency/getCurrencies'
    }),

    currencies(): ICurrency[] {
      return this.currencyRates.map((rate: ICurrencyRate) => rate.currency);
    },

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!SystemError.isSystemError(this.externalErrorMessage)) {
        errorList = this.externalErrorMessage;
      }

      if (this.fetchError) {
        errorList.push(
          this.fetchError.detail
            ? this.fetchError.detail
            : this.fetchError.message
        );
      }

      return errorList;
    }
  },

  mounted() {
    this.currencyLoading = true;
    this.fetchCurrencies(true)
      .catch(error => {
        this.fetchError = setErrorFromAxiosError(error);
      })
      .finally(() => (this.currencyLoading = false));
  },

  methods: {
    ...mapActions({
      fetchCurrencies: 'currency/fetchCurrencies'
    })
  }
});
